import { render, staticRenderFns } from "./ResourceGameActionNameFragmentInput.vue?vue&type=template&id=2c3055d2&"
import script from "./ResourceGameActionNameFragmentInput.vue?vue&type=script&lang=js&"
export * from "./ResourceGameActionNameFragmentInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports